import {
  CircularProgress as MuiCircularProgress,
  CircularProgressProps,
} from 'components/base';

export const CircularProgress = (props: CircularProgressProps) => (
  <MuiCircularProgress {...props} />
);
